<template>
  <span :class="resolutionActionClass">
    <template>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span>
            <v-icon
              v-bind="attrs"
              v-on="on"
              large
              :color="handler.color"
              @click="doHandler"
            >supervised_user_circle</v-icon>
          </span>
        </template>
        <span>Handled by Resolution Department</span>
      </v-tooltip>
    </template>
  </span>
</template>

<script>
import { DataType, Tool, Popup } from '@/util/index'
import { OriginationApi } from '@/api/pandaria'
const tool = new Tool()
const popup = new Popup()
export default {
  name: 'resolution-action',
  props: {
    loan: Object
  },
  data () {
    return {
      ResolutionFlags: {
        NOT_BE_HANDLED: 0,
        BEING_HANDLED: 1
      },
      handler: {
        color: 'primary',
        handledFlag: 0
      },
      resolutionActionClass: ''
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId: {
      handler: function () {
        if (this.$route.path.includes(DataType.RouterPath.LOS_PATH)) {
          this.resolutionActionClass = 'resolution-action-style'
        }
        this.getHandledFlag(this.loan.id)
      },
      deep: true,
      immediate: true
    }
  },
  destroyed () {
    this.$eventBus.$off('handle')
  },
  mounted () {
    this.$eventBus.$on('handle', target => {
      this.handler = {
        color: '#f44336',
        handledFlag: this.ResolutionFlags.BEING_HANDLED
      }
    })
  },
  methods: {
    getHandledFlag (loanId) {
      const request = {
        loanId: loanId,
        feature: 'HANDLE'
      }
      const $this = this
      OriginationApi.getSectionFeature(request, function (resolutionData) {
        if (tool.isNotEmpty(resolutionData)) {
          $this.handler = {
            color: '#f44336',
            handledFlag: $this.ResolutionFlags.BEING_HANDLED
          }
          if (resolutionData.handledId !== $this.store.getters.getAccount.id) {
            const roleCode = $this.store.getters.getRoleCode
            let warningMessage = ''
            if (roleCode === DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_AGENT.code || roleCode === DataType.RoleEnum.RESOLUTIONS_DEPARTMENT_MANAGER.code) {
              const resolutionName = tool.getFullName(resolutionData.handledBy)
              warningMessage = 'Loan is Handled by ' + resolutionName
            } else {
              warningMessage = 'Loan is Handled by Resolutions Department - DO NOT TOUCH.'
            }
            popup.popupForWarning(warningMessage)
          }
        }
      })
    },
    doHandler () {
      const $this = this
      const updateHandledFlag = ($this.handler.handledFlag === $this.ResolutionFlags.NOT_BE_HANDLED
        ? $this.ResolutionFlags.BEING_HANDLED : $this.ResolutionFlags.NOT_BE_HANDLED)
      const saveData = {
        loanId: this.loan.id,
        feature: 'HANDLE'
      }
      OriginationApi.updateSectionFeature(saveData, function () {
        $this.handler = {
          color: updateHandledFlag === $this.ResolutionFlags.NOT_BE_HANDLED ? 'primary' : '#f44336',
          handledFlag: updateHandledFlag
        }
        if (updateHandledFlag === $this.ResolutionFlags.BEING_HANDLED) {
          $this.$eventBus.$emit('resolutionUnlock')
        }
        $this.$forceUpdate()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .resolution-action-style {
    border-top-right-radius: 6px;
    display: block;
    position: relative;
    float: right;
    color: white;
    opacity: 0.88;
    height: 10px;
    margin-right: 10px;
    margin-top: 1px;
  }
  .material-icons.md-36 { font-size: 36px; }
  .material-icons.md-48 { font-size: 48px; }
  .group {
    display: flex;
    flex: 1;
    justify-content: space-around;
  }
</style>
